import { envBasedConfig } from "@/constants/env-based-config.constant";
import { useEffect } from "react";
import GooglePublisherTag from "./GooglePublisherTag";

const shouldHaveMembranaAds =
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  envBasedConfig.featureFlags.membranaNewsAds;

export const MembranaNewsAdsTag = (): JSX.Element => {
  const tagId = (() => {
    const id = "gpt-passback-membrana";
    return id;
  })();

  useEffect(() => {
    // Only run if membrana ads should be shown
    if (!shouldHaveMembranaAds) {
      return;
    }

    // Ensure we're in the browser and googletag is available
    if (typeof window !== "undefined") {
      googletag.cmd.push(() => {
        // Check if slot already exists to avoid duplicate definitions
        const existingSlot = googletag
          .pubads()
          .getSlots()
          .find((slot) => slot.getSlotElementId() === tagId);

        if (!existingSlot) {
          googletag
            .defineSlot("/38577695/membrana_1x1", [1, 1], tagId)
            ?.addService(googletag.pubads());

          googletag.enableServices();
        }

        // Display the ad
        googletag.display(tagId);
      });
    }

    // Cleanup function to destroy slot when component unmounts
    return () => {
      if (typeof window !== "undefined") {
        googletag.cmd.push(() => {
          const slotToDestroy = googletag
            .pubads()
            .getSlots()
            .find((slot) => slot.getSlotElementId() === tagId);

          if (slotToDestroy) {
            googletag.destroySlots([slotToDestroy]);
          }
        });
      }
    };
  }, [tagId]);

  if (!shouldHaveMembranaAds) {
    return <></>;
  }

  return (
    <>
      <GooglePublisherTag />
      <div id={tagId}></div>
    </>
  );
};
